export default __webpack_public_path__ + "static/media/premiumdentures2.d8ec1f9b.png";